import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import BeforeLoginRoute from "./resources/utils/beforeLoginRoute";
import ProtectedRouter from "./resources/utils/protectedRouter";
import { Loader } from "./components/atoms/Loader/Loader";

const LoginPage = lazy(() => import("./pages/LoginPage"));
const ForgotPasswordPage = lazy(() => import("./pages/ForgotPasswordPage"));
const VerifyOTPPage = lazy(() => import("./pages/VerifyOTPPage"));
const ResetPasswordPage = lazy(() => import("./pages/ResetPasswordPage"));
const UserManagement = lazy(() => import("./pages/UserManagement"));
const RequestedUserManagement = lazy(() =>
  import("./pages/RequestedUserManagement")
);
const CMS = lazy(() => import("./pages/CMS"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage")); // Import 404 Page

function App() {
  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <Suspense fallback={<Loader height={"100vh"} />}>
          <Routes>
            <Route
              path="/"
              element={<BeforeLoginRoute element={<LoginPage />} />}
            />
            <Route
              path="/forgot-password"
              element={<BeforeLoginRoute element={<ForgotPasswordPage />} />}
            />
            <Route
              path="/verify-otp"
              element={<BeforeLoginRoute element={<VerifyOTPPage />} />}
            />
            <Route
              path="/reset-password"
              element={<BeforeLoginRoute element={<ResetPasswordPage />} />}
            />
            <Route
              path="/users"
              element={<ProtectedRouter element={<UserManagement />} />}
            />
            <Route
              path="/requested-users"
              element={
                <ProtectedRouter element={<RequestedUserManagement />} />
              }
            />
            <Route
              path="/cms"
              element={<ProtectedRouter element={<CMS />} />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
